export const formInitialValues = {
  tree_cadastre_no: "",
  name: "",
  area: "",
  longitude: "",
  latitude: "",
  altitude: "",
  trunk_circumference: "",
  height: "",
  crown_diameter: "",
  species: "",
  phase: "",
  planting_year: "",
  soil: {
    name: null,
    pwp: null,
    max_nf: null,
    max_f: null,
  },
};

export const formUpdateValues = (formValue) => {
  // Backend now returns species.id as numeric ID
  const rawSpecies = formValue?.species?.id ?? formValue?.species_id ?? "";
  const resolvedSpecies = rawSpecies !== "" ? String(rawSpecies) : "";
  const rawPhase = formValue?.phase;
  const resolvedPhase = rawPhase != null && rawPhase !== "" ? String(rawPhase) : "";

  return {
    tree_cadastre_no: formValue && formValue.tree_cadastre_no ? formValue.tree_cadastre_no : "",
    name: formValue && formValue.name ? formValue.name : "",
    area: formValue?.area?.id || formValue?.areaId || "",
    species: resolvedSpecies,
    longitude:
      formValue && formValue.position ? (formValue.position.lng ? formValue.position.lng : "") : "",
    latitude:
      formValue && formValue?.position
        ? formValue.position.lat
          ? formValue.position.lat
          : ""
        : "",
    altitude:
      formValue && formValue.position ? (formValue.position.alt ? formValue.position.alt : "") : "",

    installations: formValue && formValue.installations ? formValue.installations : "",
    represented_trees: formValue && formValue.represented_trees ? formValue.represented_trees : "",
    trunk_circumference:
      formValue && formValue.trunk_circumference ? formValue.trunk_circumference : "",
    crown_diameter: formValue && formValue?.crown_diameter ? formValue?.crown_diameter : "",
    height: formValue && formValue.height ? formValue.height : "",
    phase: resolvedPhase,
    planting_year: formValue && formValue.planting_year ? formValue.planting_year : "",
    soil: {
      name: formValue?.soil?.name || null,
      pwp: formValue?.soil?.pwp || null,
      max_nf: formValue?.soil?.max_nf || null,
      max_f: formValue?.soil?.max_f || null,
    },
  };
};
